import React from 'react';
const workbenchImage = 'https://cdn.magicpatterns.com/uploads/nJB1C9EYy6xCKWgnmN3BAH/Plantillas_Punniken_met_Liefde_NL.png';
const steps = [{
  title: 'Kies je project',
  text: 'Zoek een motief dat je mooi vindt en begin met een vorm die bij je niveau past.'
}, {
  title: 'Leg materialen en sjabloon klaar',
  text: 'Lees de handleiding, pak je gereedschap erbij en print het sjabloon op het formaat dat bij je project past.'
}, {
  title: 'Punnik en vorm',
  text: 'Maak je punnikkoord en vorm het volgens de techniek uit de handleiding en het sjabloon dat je hebt gekozen.'
}, {
  title: 'Afwerken en personaliseren',
  text: 'Werk de uiteinden en details netjes af en kies daarna hoe je je creatie wilt presenteren.'
}];
export function HowItWorks() {
  return <section aria-labelledby="how-title" className="on-dark bg-plum text-cream px-5 sm:px-8 py-16 sm:py-24" data-id="element-116" data-mp="gr734eleeokz">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 lg:grid-rows-[auto_1fr] gap-x-16 gap-y-10" data-id="element-117" data-mp="199ulhm90fpid">
        <div className="lg:col-start-2 lg:row-start-1" data-id="element-118" data-mp="2rleiskcu206y">
          <h2 id="how-title" className="font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold" data-id="element-119" data-mp="2rm7k35t0vxhp">
            Van sjabloon tot je eigen creatie, stap voor stap.
          </h2>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-cream/85 max-w-lg" data-id="element-120" data-mp="31c949mi98vrc">
            Begin met een eenvoudige vorm en gebruik het sjabloon als houvast terwijl je leert punnikkoord te maken en te vormen.
          </p>
        </div>

        <figure className="lg:col-start-1 lg:row-start-1 lg:row-span-2" data-id="element-121" data-mp="36ake3x8jv69k">
          <div className="aspect-[4/3] overflow-hidden rounded-[2rem] ring-1 ring-butter/50" data-id="element-122" data-mp="36aaklzoaqgz4">
            <img src={workbenchImage} alt="Werktafel met geprinte sjablonen van Punniken met Liefde: de letters A en a, de cijfers 1 en 2, een beertje en twee vlinders. Een hand legt roze punnikkoord langs de omtrek van het beertje, naast een printer, een vlinder van punnikkoord, pastelkleurige bolletjes garen, een houten punnikklosje, metaaldraad en een tang" loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-123" data-mp="3k9k355zz5n69" />
          </div>
          <figcaption className="mt-4 text-center text-xs font-semibold tracking-[0.08em] sm:tracking-[0.18em] text-cream/80" data-id="element-124" data-mp="3py1wvba2s7ks">
            KIES · LEG KLAAR · VORM · PERSONALISEER
          </figcaption>
        </figure>

        <ol className="lg:col-start-2 lg:row-start-2 self-start" data-id="element-125" data-mp="2ux2gnw3b00g">
          {steps.map((step, i) => <li key={step.title} className="relative grid grid-cols-[2.75rem_1fr] gap-x-4 pb-8 last:pb-0" data-id="element-126" data-mp="7tqgqij7av1o" data-mpi={i}>
              {i < steps.length - 1 && <span aria-hidden="true" className="absolute left-[1.375rem] top-12 bottom-1 w-px bg-cream/25" data-id="element-127" data-mp="cq78rntittk1" />}
              <span className="flex h-11 w-11 items-center justify-center rounded-full border border-cream/35 font-serif text-lg font-semibold text-berry-light" data-id="element-128" data-mp="hkuwhkgpajxk">
                {i + 1}
              </span>
              <div className="pt-1.5" data-id="element-129" data-mp="qhlsjwv95ys5">
                <h3 className="font-serif text-xl font-semibold" data-id="element-130" data-mp="vhqbdtjmv5lj">{step.title}</h3>
                <p className="mt-1.5 text-base leading-relaxed text-cream/80" data-id="element-131" data-mp="15m6l056irqgw">{step.text}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}